import { generateTableSlice } from "./sliceTable";

const sliceTaskTable = generateTableSlice("task");

export const ActionsTaskTable = sliceTaskTable.actions;
export const ReducerTaskTable = sliceTaskTable.reducer;
